// @flow

import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1000px) {
    flex-flow: row nowrap;
  }
`;
